<template>
    <section>
        <div class="content">
            <p>感谢您选择用心淘服务下单平台服务。用心淘服务下单平台服务协议（以下简称“本协议”）由惠州用心淘电子商务有限公司（以下简称“用心淘”或“我们”）和您签订。</p>
            <p>在同意本协议前，请您认真阅读并充分知悉、理解用心淘的各项规则及要求，以及国家关于该类互联网信息服务的法律法规等。</p> 
            <p>如果您对本协议的任何条款表示异议，您可以选择不使用；使用则意味着您将同意遵守本协议下全部规定，以及我们后续对使用协议随时所作的任何修改，并完全服从于我们的统一管理。</p> 
            <p>请确认您具有完全民事行为能力，如您已年满18周岁，或您已年满16周岁且依靠自己的劳动收入作为主要生活来源，否则请您停止注册或使用本协议项下的服务。</p> 
            
            <h4>1、关于充值</h4>
            <p>钱包金额是用心淘为用户提供的用于平台相关消费的虚拟货币，也是用心淘充值平台的中间货币, 钱包金额不能兑换成人民币。</p>   
                  
            <h4>2、服务内容</h4>
            <p>用心淘的充值系统提供微信支付，银联支付等不同的充值方式，涵盖了银行卡、微信充值等充值操作办法。用户使用该平台进行充值，可以为用心淘充值钱包金额或以增加用户帐号所有的虚拟币的数量。</p>      
      
            <h4>3、操作方法</h4>
            <p>3.1 用户可以在此充值系统上自由选择具体的充值方式，并按相应页面提示的程序完成充值。</p>      
            <p>3.2 用户使用各种充值方式进行充值后，应保留充值订单号或充值截图以作为今后发生问题核对依据凭证（用户就充值服务投诉，但未有任何充值记录或其他有效凭证佐证的，用心淘将不会作出任何补偿或赔偿）。</p>
            
            <h4>4、风险提示</h4>
            <p>4.1 在使用充值方式时，用户务必仔细确认自己的帐号并仔细选择相关操作选项。若因为用户自身输入帐号错误、操作不当或不了解充值计费方式等因素造成充错帐号、错选充值种类等情形而损害自身权益的，用心淘将不会作任何补偿或赔偿。</p>
            <p>4.2 若用户以非法的方式，或使用非用心淘所指定的充值方式进行充值，用心淘不保证该充值顺利或者正确完成。若因此造成用户权益受损时，用心淘不会作任何补偿或赔偿，用心淘同时保留随时终止该用户账号资格及使用各项充值服务的权利。</p>
            
                
            <h4>5、充值成功后</h4>
            <p>充值成功后，充值所增加的账号内虚拟货币可由用户自由使用，但用心淘不会提供任何退还或逆向兑换服务。</p>    
            
            <h4>6、若因用心淘充值方式原因造成用户充值失实并经查证属实的，用心淘将根据用户充值情况作出变动措施</h4>
            <p>6.1 因充值方式原因，造成系统充值额小于用户实际充值额的，用心淘予以补其差额；</p>
            <p>6.2 因充值方式原因，造成系统充值额大于用户实际充值额的，用心淘有权追回差额；</p>

            <h4>7、服务变更、中断或终止</h4>
            <p>7.1 用心淘可以根据业务需求随时变更服务或更新本协议的条款，但应在相关的页面上及时提示修改内容。修改后的服务协议一旦在页面上公布即代替原来的服务协议。</p>
            <p>7.2 如因系统维护或升级的需要而需暂停网络充值服务，用心淘将尽可能事先进行通告。</p>
            <p>7.3 如发生下列任何一种情形，用心淘有权随时中断或终止向用户提供本协议项下的网络服务而无需通知用户：</p>
            <p>(a) 用户提供的个人资料不真实；</p>
            <p>(b) 用户违反本协议中规定的使用规则。</p>
            <p>7.4 除前款所述情形外，用心淘同时保留在不事先通知用户的情况下随时中断或终止部分或全部网络充值服务的权利，对于充值服务的中断或终止而造成的任何损失，用心淘无需对用户或任何第三方承担任何责任。</p>
    
            
            <h4>8. 免责声明和损害赔偿</h4>
            <p>8.1发生下列情况时，用心淘免于承担任何法律责任：</p>
            <p>（a）用户因使用第三方支付渠道充值过程中发生的相关争议；</p>
            <p>（b）由于用户将密码告知他人导致的用户财产损失； </p>
            <p>（c）因用户个人故意或重大过失，或本协议之外的第三方所造成的用户财产损失；</p>
            <p>（d）由不可抗力及不可预见的情势导致的各种情况和纠纷；不可抗力和不可预见情势包括：黑客攻击、电信部门技术调整导致重大影响、政府管制导致的暂时关闭、病毒侵袭。</p>
            <p>8.2 用户同意保障和维护用心淘及其他用户的利益，如因用户违反有关法律、法规或本协议项下的任何条款而给用心淘或任何其他第三人造成损失，用户同意承担由此造成的损害赔偿责任。</p>
            
            <h4>9.其他</h4>
            <p>9.1 本协议的订立、执行和解释及争议的解决均应适用中国法律。</p>
            <p>9.2 如双方就本协议内容或其执行发生任何争议，双方应尽量友好协商解决；协商不成时，任何一方均应向广州市天河区人民法院提起诉讼。</p>
            <p>9.3 本协议内容同时包括用心淘可能不断发布的关于本服务的相关协议、业务规则等内容。上述内容一经正式发布，即为本协议不可分割的组成部分，具有同等法律效力。</p>
            <p>9.4 本协议项下所有的通知均可通过重要页面公告、电子邮件或常规的信件传送等方式进行；该等通知于发送之日视为已送达收件人。</p>
            
            <h4>10、知识产权的保护 </h4>
            <p>10.1、我们及关联公司的系统及用心淘网站上的内容，包括但不限于著作、图片、档案、资讯、资料、网站架构、网站画面的安排、网页设计，均由我们或关联公司依法拥有知识产权，包括但不限于商标权、专利权、著作权、商业秘密等。 </p>
            <p>10.2、非经我们或关联公司书面同意，请勿擅自使用、修改、反向编译、复制、公开传播、改变、散布、发行或公开发表支付宝网站程序或内容。</p>
            <p>10.3、尊重知识产权是您应尽的义务，如有违反，您需要承担损害赔偿责任。</p>
            <h4>11、法律适用与管辖 </h4>
			<p>本协议之效力、解释、变更、执行与争议解决均适用中华人民共和国法律。因本协议产生的争议，均应依照中华人民共和国法律予以处理，并由被告住所地人民法院管辖。</p>
		</div>
    </section>
</template>  
<script>
    import CommonHeader from '@/components/CommonHeader'
    export default {
        name: 'agree-ment',
        components: {
            CommonHeader,
        },
        
        mounted(){
            document.title = "充值服务协议"
        } 
    }
</script>

    
<style lang='less' scoped>
    @import '~@/assets/styles/variable.less';
    @import '~@/assets/styles/handleMethods.less';
    @import '~@/assets/styles/reset.css';
	section{background: #fff}
    .txt-middle{text-align:center;.f-s(20)}
    .content{padding-bottom: 20px;}
    h3,h4{.p-b(5);.p-t(5);.p-l(10);.p-r(10);.m-t(14);;.m-l(0);.m-r(0);font-size:16px;}
    p{.p-b(5);.p-t(5);.p-l(10);.p-r(10);.f-s(14);.l-h(20);}
    p{padding:5px 10px; font-size:14px; line-height:20px; margin:0 auto;}
</style>
